import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { useState } from "react";
import { FiSearch } from "react-icons/fi";

export function RaffleCreateCampaignCodeBySearch() {
  // --- Default Variables --- //
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  // --- Search Campaign Code Control --- //
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState<
    { id: number; code: string; name: string; status: string }[]
  >([]);

  const existingCampaigns = [
    {
      id: 1,
      code: "iphone-15-pro",
      name: "Campanha iPhone 15 Pro",
      status: "ativa",
    },
    {
      id: 2,
      code: "samsung-galaxy-s24",
      name: "Campanha Samsung Galaxy S24",
      status: "pausada",
    },
    {
      id: 3,
      code: "notebook-gamer",
      name: "Campanha Notebook Gamer",
      status: "ativa",
    },
    {
      id: 4,
      code: "black-friday-2024",
      name: "Black Friday 2024",
      status: "finalizada",
    },
    {
      id: 5,
      code: "black-friday-2024",
      name: "Black Friday 2024",
      status: "finalizada",
    },
    {
      id: 6,
      code: "black-friday-2024",
      name: "Black Friday 2024",
      status: "finalizada",
    },
    {
      id: 7,
      code: "black-friday-2024",
      name: "Black Friday 2024",
      status: "finalizada",
    },
    {
      id: 8,
      code: "black-friday-2024",
      name: "Black Friday 2024",
      status: "finalizada",
    },
    {
      id: 9,
      code: "black-friday-2024",
      name: "Black Friday 2024",
      status: "finalizada",
    },
    {
      id: 10,
      code: "black-friday-2024",
      name: "Black Friday 2024",
      status: "finalizada",
    },
  ];

  const handleSearch = () => {
    // if (searchTerm.trim()) {
    //   const results = existingCampaigns.filter(
    //     (campaign) =>
    //       campaign.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //       campaign.name.toLowerCase().includes(searchTerm.toLowerCase())
    //   );
    //   setSearchResults(results);
    // } else {
    //   setSearchResults(existingCampaigns);
    // }

    return pushToastify({
      message: "Em construção...",
      type: "info",
      theme: "dark",
    });
  };

  return (
    <>
      <div className="">
        <div className="mb-3">
          <label htmlFor="searchCampaign" className="form-label">
            Buscar Campanha Existente
          </label>
          <div className="input-group">
            <input
              id="searchCampaign"
              type="text"
              className="form-control"
              placeholder="Digite o código ou nome da campanha"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()}
            />
            <button
              className="btn btn-outline-primary"
              onClick={handleSearch}
              type="button"
            >
              <FiSearch />
            </button>
          </div>
        </div>

        {/* The Search Result */}
        {searchResults.length > 0 && (
          <div className="mt-3">
            <h6 className="mb-3">Campanhas Encontradas:</h6>
            <div className="list-group">
              {searchResults.map((campaign) => (
                <div
                  key={campaign.id}
                  className="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                  style={{ cursor: "pointer" }}
                  // onClick={() => handleSelectCampaign(campaign)}
                >
                  <div>
                    <h6 className="mb-1">{campaign.name}</h6>
                    <p className="mb-1 text-muted">
                      Código: <code>{campaign.code}</code>
                    </p>
                  </div>
                  <div>
                    <span
                      className={`badge bg-${
                        campaign.status === "ativa"
                          ? "success"
                          : campaign.status === "pausada"
                          ? "warning"
                          : "secondary"
                      }`}
                    >
                      {campaign.status}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {searchTerm && searchResults.length === 0 && (
          <div className="alert alert-info mt-3">
            <FiSearch className="me-2" />
            Nenhuma campanha encontrada com o termo "{searchTerm}".
          </div>
        )}
      </div>
    </>
  );
}
